/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2021 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React from 'react';
import styles from './messages.scss';

export function ErrorMessage(props) {
    return <span className={`${styles['messaging']} ${styles['error']}`}>
        <svg className={styles['icon']} xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <g fill="none" fill-rule="evenodd">
                <g>
                    <g>
                        <g>
                            <path d="M0 0H18V18H0z" transform="translate(-8 -4) translate(8) translate(0 4)" />
                            <g fill="#DB0020">
                                <path fill-rule="nonzero" d="M6.945 1.123L.301 12.628c-.197.342-.301.73-.301 1.125C0 14.993 1.005 16 2.245 16h13.288c.395 0 .783-.104 1.124-.302 1.073-.622 1.44-1.996.82-3.07L10.831 1.123c-.196-.34-.479-.623-.819-.82-1.073-.622-2.447-.255-3.068.82zm2.177.718c.07.04.13.1.17.171l6.645 11.505c.13.225.053.513-.171.643-.071.04-.151.062-.233.062H2.245c-.258 0-.467-.21-.467-.47 0-.082.022-.163.063-.235L8.485 2.012c.115-.2.353-.281.56-.207l.077.036z" transform="translate(-8 -4) translate(8) translate(0 4) translate(0 1)" />
                                <path d="M8.444 11.556C8.2 11.556 8 11.755 8 12v.889c0 .246.199.444.444.444h.89c.245 0 .444-.198.444-.444V12c0-.245-.2-.444-.445-.444h-.889zM8.444 6.222c-.245 0-.444.2-.444.445v3.555c0 .246.199.445.444.445h.89c.245 0 .444-.2.444-.445V6.667c0-.246-.2-.445-.445-.445h-.889z" transform="translate(-8 -4) translate(8) translate(0 4) translate(0 1)" />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
        <span className={`${styles['message']} ${styles['error']}`}>{props.message}</span>
    </span>
}